let currentSlide = 0;
const slides = document.querySelectorAll(".custom-review-slide");
const dots = document.querySelectorAll(".custom-dot");

function showSlide(index) {
  if (index >= slides.length) {
    currentSlide = 0;
  } else if (index < 0) {
    currentSlide = slides.length - 1;
  }

  slides.forEach((slide, i) => {
    slide.classList.remove("active");
    slide.classList.remove("previous");

    // Move the active slide into view
    if (i === currentSlide) {
      slide.classList.add("active");
    }
    // Move the previous slide out of view
    else if (
      i === currentSlide - 1 ||
      (currentSlide === 0 && i === slides.length - 1)
    ) {
      slide.classList.add("previous");
    } else {
      slide.classList.remove("previous");
    }
  });

  dots.forEach((dot) => dot.classList.remove("active"));
  dots[currentSlide].classList.add("active");
}

function nextSlide() {
  currentSlide++;
  showSlide(currentSlide);
}

setInterval(nextSlide, 10000); // Change slide every 5 seconds

// Initialize the first slide as active
showSlide(currentSlide);

// Add event listeners for dots (optional)
dots.forEach((dot, index) => {
  dot.addEventListener("click", () => {
    currentSlide = index;
    showSlide(currentSlide);
  });
});
